import React, { useState, useEffect } from "react";
// Chakra imports
import {
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon
} from "@chakra-ui/react";
import { FaEye, FaCreditCard, FaAdjust, FaCogs, FaWrench, FaCheckCircle } from "react-icons/fa";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
import IconBox from "components/Icons/IconBox";
// Custom icons
import { SupportIcon } from "components/Icons/Icons.js";
// Custom components
import useGetOrdersMechanicSummary from "hooks/useGetOrdersMechanicSummary";

function MechanicSummary() {

    const textColor = useColorModeValue("gray.700", "white");

    let { 
      orders, 
      setGettingOrders, 
      gettingOrders, 
      gettingOrdersReqSuccess 
    } = useGetOrdersMechanicSummary({});

    // const reloadTable = () => {
    //   setGettingOrders(true);
    // }

    useEffect(() => {
      setGettingOrders(true);
    }, []);


    // useEffect(() => {
    //   console.log(orders);
    // }, [orders]);



    return ( 
        <Flex direction="column"
        style={{
          maxHeight: '380px',
          overflowY: 'auto'
        }}>

          {orders.length == 0
            ? <Text fontWeight="bold" as="span" color="grey">
              N/A
            </Text>
            : null
          }
      
          <Flex direction="column">
            {orders.map((m) => {
              if (m.carPlates.length == 1 && m.carPlates[0] == null ) {
                return;
              }

              return <Flex 
                alignItems="center" 
                minH="78px" 
                justifyContent="start" 
                mb="5px"
                key={`mechanic-${m.id}`}
                >
                <Flex direction="column" h="100%">
                  <IconBox as="box" h={"45px"} w={"45px"} >
                    <SupportIcon h={"24px"} w={"24px"} color={"orange"} />
                  </IconBox>
                </Flex>
                <Flex direction="column" justifyContent="flex-start" h="100%">
                  <Text fontSize="sm" color={textColor} fontWeight="bold">
                    {m.firstName} {m.lastName}
                  </Text>
                  {m.carPlates.map((cp) => {
                    return <Text 
                    fontSize="sm" 
                    color="gray.400" 
                    fontWeight="normal"
                    key={`mechanic-cp-${m.id}-${cp}`}
                    >
                      {cp}                
                    </Text>
                  })}
                </Flex>
              </Flex>
            })}
          </Flex>
          
      </Flex>
       
    )
}


export default MechanicSummary;